import React from 'react'
import { ProgressBar } from 'react-bootstrap'
import { humanReadableByteCount } from './../../lib/helper'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'

class CloudwaysStats extends React.Component {
	render() {
		const { migrate, cancel, progress } = this.props
		return <div className="cws d-flex">
			<div className="container">
				<div className="row">
					<div className="col-lg-12">
						<div className="migration-box text-center">
							<div>
								<img className="bv-logo" src="/assets/blog-vault-logo@2x.png" alt=""/>
								<h1 className="font-36 color-0E134F proxima-regular mt-1 mb-2">Your site is being migrated to Cloudways!</h1>
								<p className="v-center py-1" style={{justifyContent: 'center'}}>
									<a href={migrate.get('source_site')} target="_blank" rel="noreferrer" className="color-2D38BB proxima-regular font-18 td-none">
										{migrate.get('source_site')}
									</a>
									<img className="arrow-icon" src="/assets/cloudways/cws-blue-arrow.svg" alt=""/>
									<a href={migrate.get('destination_site')} target="_blank" rel="noreferrer" className="color-2D38BB proxima-regular font-18 td-none">
										{migrate.get('destination_site')}
									</a>
								</p>
							</div>
							<div className="cw-border-1 mt-2 mb-4"/>
							<div className="mt-5 mb-5 migrate-process-box">
								<div className="subsection">
									<h2 className="font-16  color-0E134F proxima-regular fw-600 my-1">
										Sit back and relax while BlogVault robots move your site.
									</h2>
									<p className="font-13 color-42526E proxima-regular mb-3">
										You can monitor the progress, or close the window and wait for the completion email to arrive in your inbox.
									</p>
								</div>
								<div className="progress-group">
									<p className="font13 color-42526E proxima-regular text-left mb-1">
										{ humanReadableByteCount(migrate.getIn(['status', 'files', 'size', 'synced'])) }/{ humanReadableByteCount(migrate.getIn(['status', 'files', 'size', 'total']) - migrate.getIn(['status', 'files', 'size', 'ignored'])) } - Files Synced
									</p>
									<ProgressBar now={migrate.getIn(['status', 'files_progress'])} className="custom-progress"/>
									<div className="progress-percentage font16">
										{migrate.getIn(['status', 'files_progress'])}%
									</div>
								</div>
								<div className="progress-group">
									<p className="font13 color-42526E proxima-regular text-left mb-1">
										{ migrate.getIn(['status', 'database', 'synced']) }/{ migrate.getIn(['status', 'database', 'total']) - migrate.getIn(['status', 'database', 'ignored']) } - Tables Synced
									</p>
									<ProgressBar bsStyle="success" now={migrate.getIn(['status', 'tables_progress'])} className="custom-progress"/>
									<div className="progress-percentage font16">
										{migrate.getIn(['status', 'tables_progress'])}%
									</div>
								</div>
								<div className="progress-group">
									<p className="font13 color-42526E proxima-regular text-left mb-1">Overall Migration</p>
									<ProgressBar bsStyle="info" now={progress} className="custom-progress"/>
									<div className="progress-percentage font16">
										{progress}%
									</div>
								</div>
								<a className="red-button mt-5 block bv-underline" onClick={cancel}>CANCEL MIGRATION</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	}
}

CloudwaysStats.propTypes = {
	migrate: ImmutablePropTypes.map,
	cancel: PropTypes.func,
	progress: PropTypes.number
}

export default CloudwaysStats
